export type FetchOptions = RequestInit & { timeoutMs?: number };

// Fetch helper that aborts after the configured timeout and returns response text.
export function fetchText(url: string, opts: FetchOptions = {}): Promise<string> {
  const controller = new AbortController();
  const timeout = opts.timeoutMs ?? 10000;
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  return fetch(url, { ...opts, signal: controller.signal })
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch topbar (${response.status})`);
      return response.text();
    })
    .finally(() => clearTimeout(timeoutId));
}

// Fetch helper that aborts after the configured timeout and returns response json.
export function fetchJson<T>(url: string, opts: FetchOptions = {}): Promise<T> {
  const controller = new AbortController();
  const timeout = opts.timeoutMs ?? 10000;
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  return fetch(url, { ...opts, signal: controller.signal })
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch json (${response.status})`);
      return response.json() as Promise<T>;
    })
    .finally(() => clearTimeout(timeoutId));
}
